export default __webpack_public_path__ + "components/page-footer/static/app-store-969642b47a537eefe45f64aaa42f530b.svg";